import { useEffect } from 'react';
import axios from 'axios';


export function Olc() {

  useEffect(() => {
    axios.get("/api/redirect/olcurl")
      .then((response) => {
        window.location.href = response.data;
      });
  }, []);

  return <></>;
}
